import { Injectable, ɵConsole } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs/operators';
declare var $: any; // TODO hide modal in othe way

import { environment } from "@environments/environment";

// Interfaces
import { UserInterface, ResponseDataBase } from '@interfaces/index.interface';

// Services
import { ResourceService } from "@services/resource/resource.service";

@Injectable()
export class UserService {
  backURL = environment.BACKURL;
  loading: boolean;
  user: any;
  danger: string;
  warning: string;
  success: string;
  token: string;
  lastActivityTime;
  checkForActivity;

  constructor(public router: Router,
    public http: HttpClient,
    public translate: TranslateService,
    public _resourceService: ResourceService) {

    if (typeof sessionStorage.dataPatient !== 'undefined') {
      this.user = JSON.parse(sessionStorage.getItem('dataPatient'));
      // Si tenemos el usuario reiniciamos la cuenta de actividad.
      this.lastActivityTime = +new Date();
      let self = this;
      this.checkForActivity = setInterval(function () {
        self.checkForActivityAction();
      }, 1000);
    }
  }

  getData(params) {
    if (params) {
      this.getDependentData(params);
    } else {
      this.getPatientData();
    }
  }

  getPatientData() {
    this.loading = true;
    this.http.get(this.backURL + 'rest/patient')
      .subscribe(
        RES => {
          if (!Object.keys(RES).length) {
            this.danger = "The user don't exits, please register it";
            this.loading = false;
          } else {
            delete this.danger;
            // this.user = Object.values(RES)[0][0]; This more clean code is not valid for Explorer, insted we use this other aprroch
            let user = Object.keys(RES).map(function (itm) { return RES[itm][0]; });
            this.user = user[0];
            if (!this.user.patnr && environment.envName == 'hasis') {
              this.warning = 'WARNING_NOT_PATNR';
              $('#RememberFilationModal').modal('show');
            }
            if (this.user.locked) {
              this.warning = 'USER_LOCKED';
              $('#RememberFilationModal').modal('show');
              this.doLogout();
            } else {
              this.getDependents().subscribe(data => {
                let response = data as ResponseDataBase;
                this.user.dependents = response.result;
                this.loading = false;
                sessionStorage.setItem('dataPatient', JSON.stringify(this.user));
                // This is the navigation after complete. I try TODO it when finish but say my this.user.dependents as undefined;
                if (this.router.url == '/secondopinion' || this.router.url == '/user/mydocuments') {
                  this.getPatientDocuments().subscribe(data => {
                    let response = data as ResponseDataBase;
                    if (response.METADATA.STATUS === "0") {
                      let response = data as ResponseDataBase;
                      this.user.documents = response.result;
                      this._resourceService.loading = false;
                    } else {
                      this._resourceService.loading = false;
                    }
                  });
                  // Stay in secondopinion
                } else if (this._resourceService.selectedFreeslot || this.user.passInitial) {
                  this.router.navigate(['/bookappointments']);
                } else if (this.user.role == 'admin' || this.user.role == 'superadmin') {
                  if (environment.ADMINNAVBAR.HAS) {
                    this.router.navigate(['/admin/user-management']);
                  } else {
                    // Si es admin pero no tiene activada la opción nos vamos al perfil para darnos cuenta
                    this.router.navigate(['/user/accountinfo']);
                  }
                } else if (environment.RESOURCES_ON_DATABASE && this.user.role == 'consultant') {
                  this.router.navigate(['/admin/database-resources/consultants/edit-consultant']);
                } else if (environment.RESOURCES_ON_DATABASE && this.user.role == 'assistant') {
                  this.router.navigate(['admin/database-resources/consultants']);
                } else {
                  this.router.navigate(['/user/myappointments']);
                }
              });
              if (this.user.language && !environment.HIDELANGUAGESELECTOR) {
                this.translate.use(this.user.language);
              } else {
                this.translate.use(this._resourceService.defaultLanguage);
              }
              if (this.user.status == '0') {
                this.router.navigate(['/bookappointments']);
              }
              sessionStorage.setItem('dataPatient', JSON.stringify(this.user));
            }
          }
          if (this._resourceService.selectedFreeslot) {
            $('#FreeSlotModal').modal('show');
          }
        },
        error => {
          console.log('Error: ', error);
        },
        () => {
          // Somthing to do when the observable is completed.');
        }
      );
  }

  resendActivationMail(email) {
    let params = {
      email: email
    }
    let url = this.backURL + 'rest/user/sendactivation';
    return this.http.post(url, params);
  }

  getDependentData(params) {
    this.loading = true;
    this.http.get(this.backURL + 'rest/patient', { params: params })
      .subscribe(
        RES => {
          if (!Object.keys(RES).length) {
            this.danger = "The user don't exits, please register it";
            this.loading = false;
          } else {
            delete this.danger;
            if (this._resourceService.selectedFreeslot) {
              this.router.navigate(['/bookappointments']);
            } else {
              this.router.navigate(['/user/myappointments']);
            }

            // this.user = Object.values(RES)[0][0]; This more clean code is not valid for Explorer, insted we use this other aprroch
            let dependent = Object.keys(RES).map(function (itm) { return RES[itm][0]; });


            dependent = dependent[0];
            if (this.user.papid || this.user.patnr) {
              this.getPatientAppointments().subscribe(data => {
                let response = data as ResponseDataBase;
                this.user.appointments = response.result;
                this.loading = false;
              });
            } else {
              this.user.appointments = [];
              this.loading = false;
            }
            sessionStorage.setItem('dataPatient', JSON.stringify(this.user));
          }
          if (this._resourceService.selectedFreeslot) {
            $('#FreeSlotModal').modal('show');
          }
        },
        response => {
        },
        () => {
          // Somthing to do when the observable is completed.');
        }
      );
  }

  getAppointments(params) {
    if (params) {
      return this.getDependentAppointments(params)
    } else {
      return this.getPatientAppointments();
    }
  }

  getPatientAppointments() {
    this.loading = true;
    let url = this.backURL + 'rest/patient/appoiments';
    // this.checkAuthoritation(url);
    return this.http.get(url);
  }

  checkError(err) {
    if (err.status == 401) {
      this.warning = "INVALID_TOKEN";
      $('#LoginModal').modal('show');
      this.doLogout();
      this.loading = false;
    }
  }


  printAppointment(appointmenID) {
    this.loading = true;
    let url = this.backURL + 'rest/patient/getpdfappointment';
    return this.http.get(url, { params: appointmenID });
  }

  getDependentAppointments(params) {
    this.loading = true;
    let url = this.backURL + 'rest/patient/appoiments';
    return this.http.get(url, { params: params });
  }

  addDependent(params) {
    this.loading = true;
    let url = this.backURL + 'rest/patient/adddependent';
    return this.http.post(url, params)
  }

  getPatientDocuments() {
    this._resourceService.loading = true;
    let url = this.backURL + 'rest/patient/getmydocuments';
    return this.http.get(url);
  }

  getPatientDocument(document) {
    this._resourceService.loading = true;
    let url = this.backURL + 'rest' + document.hrefReports;
    return this.http.get(url);
  }

  getDependents() {
    this.loading = true;
    let url = this.backURL + 'rest/patient/dependents';
    return this.http.get(url);
  }

  updateUser(user: UserInterface) {
    this.loading = true;
    sessionStorage.setItem('dataPatient', JSON.stringify(this.user));
    let url = this.backURL + 'users/' + this.user.id + '.json';
    let body = JSON.stringify(user);
    let headers = new HttpHeaders({
      'Content-Type': 'aplication/json'
    });
    return this.http.put(url, body, { headers })
      .pipe(map(res => {
        return res;
      }));
  }

  deleteUser(params) {
    this.loading = true;
    let url = this.backURL + 'rest/user/deleteuser';
    return this.http.delete(url, { params: params })
      .pipe(map(res => {
        return res;
      }));
  }

  lockUser(params) {
    this.loading = true;
    let url = this.backURL + 'rest/user/lockuser';
    return this.http.post(url, params)
  }

  unlockUser(params) {
    this.loading = true;
    let url = this.backURL + 'rest/user/unlockuser';
    return this.http.post(url, params)
  }

  doLogout() {
    let params = {
      'email': this.user.email
    }
    this.backLogout(params).subscribe();
    delete this._resourceService.alert;
    sessionStorage.clear();
    clearInterval(this.checkForActivity);
    this.router.navigate(['/bookappointments']);
    delete this._resourceService.selectedFreeslot;
    this.translate.use(this._resourceService.defaultLanguage);
    delete this.user;
    this.loading = false;
  }

  backLogout(params) {
    let url = this.backURL + 'rest/user/logout';
    return this.http.post(url, params)
  }

  generatePin(params) {
    this.loading = true;
    let url = this.backURL + 'rest/admin/generatepin';
    return this.http.post(url, params)
  }

  sendpasstorolewithoutpass(params) {
    this.loading = true;
    let url = this.backURL + 'rest/admin/sendpasstorolewithoutpass';
    return this.http.post(url, params)
  }

  registerUser(params) {
    this.loading = true;
    let url = this.backURL + 'rest/user/registeruser';
    return this.http.post(url, params)
  }

  registerAdminUser(params) {
    this.loading = true;
    let url = this.backURL + 'rest/admin/registeruser';
    return this.http.post(url, params)
  }

  removeDependency(params) {
    this.loading = true;
    let url = this.backURL + 'rest/patient/removedependency';
    return this.http.post(url, params)
  }

  getpatientpin(params) {
    this.loading = true;
    let url = this.backURL + 'rest/user/getpatientpin';
    return this.http.get(url, { params: params });
  }
  changeUserMail(params) {
    this.loading = true;
    let url = this.backURL + 'rest/user/updateemail';
    return this.http.post(url, params)
  }

  changeUserPass(params) {
    this.loading = true;
    let url = this.backURL + 'rest/user/updatepassword';
    return this.http.post(url, params)
  }

  changeUserRole(params) {
    this.loading = true;
    let url = this.backURL + 'rest/user/updatesettings';
    console.log(params);
    return this.http.post(url, params)
  }

  setUserData(action, params) {
    this.loading = true;
    let url = this.backURL + 'rest/user/' + action;
    return this.http.post(url, params)
  }

  doActionPatient(action, params) {
    this.loading = true;
    let url = this.backURL + 'rest/patient/' + action;
    return this.http.put(url, params);
  }

  passToWaitingRoom(params) {
    let url = this.backURL + 'rest/patient/admitpatient';
    return this.http.post(url, params)
  }

  dependantIsFamiliar(idUser, idDependent) {
    if (environment.envName == 'typet') {
      idUser = idUser.substr(1, 6);
      idDependent = idDependent.substr(1, 6)
      if (idUser == idDependent) {
        return true
      } else {
        return false;
      }
    }
    return true;
  }

  searchUsers(params) {
    this.loading = true;
    let url = this.backURL + 'rest/user/getusers';
    if (environment.NAME == 'typet') {
      url += '?';
      Object.keys(params).forEach(function (key) {
        url += key + '=' + params[key]
      });
      return this.http.get(url);
    } else {
      return this.http.get(url, { params: params });
    }
  }

  getRegisteredUsers(params) {
    this.loading = true;
    let url = this.backURL + 'rest/user/getregisteredusers';
    return this.http.get(url, { params: params });
  }

  getDeletedUsers(params) {
    this.loading = true;
    let url = this.backURL + 'rest/user/getdeletedusers';
    return this.http.get(url, { params: params });
  }

  checkForActivityAction() {
    let maxInactiveTime = environment.MAXINACTIVETIME;
    if (+new Date() - this.lastActivityTime > maxInactiveTime) {
      this._resourceService.alert = 'LOGOUT_FOR_INACTIVITY';
      $('#LoginModal').modal('show');
      this.doLogout();
    }
  }

  getPatientDatabaseAppointments() {
    this.loading = true;
    let url = this.backURL + 'rest/patient/getdatabaseappointments';
    return this.http.get(url);
  }

  bookDatabaseSlot(params) {
    this.loading = true;
    let url = this.backURL + 'rest/patient/bookdatabaseslot';
    return this.http.post(url, params);
  }

  cancelDatabaseSlot(params) {
    this.loading = true;
    let url = this.backURL + 'rest/patient/canceldatabaseslot';
    return this.http.put(url, params);
  }

  clearAlerts() {
    delete this.danger;
    delete this.warning;
    delete this.success;
  }
}
